<template>
  <div>
    <v-tabs v-model="polTabs" icons-and-text>
      <v-tab ripple :key="1" @click="doTab(0)">Policy Summary<v-icon color="cyan">mdi-table-large</v-icon></v-tab>
      <v-tab ripple :key="2" @click="doTab(1)" :disabled="!(polMaster.totNoInstal > 1)"
        >Instalments<v-icon color="cyan">mdi-cash-multiple</v-icon></v-tab
      >
      <v-tab ripple :key="3" v-if="showTab" @click="doTab(2)">Amend Retention<v-icon color="cyan">mdi-auto-fix</v-icon></v-tab>
    </v-tabs>
    <v-tabs-items v-model="polTabs" :touchless="true">
      <v-tab-item :key="1" :transition="false" :reverse-transition="false">
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <QueryPolicySummary ref="policysummary"></QueryPolicySummary>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2" :transition="false" :reverse-transition="false">
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <QueryPolicyInstalments ref="policyInstal"></QueryPolicyInstalments>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="3" :transition="false" :reverse-transition="false">
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <QueryPolicyAmendRetention ref="policyAmend"></QueryPolicyAmendRetention>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import QueryPolicySummary from './QueryPolicySummary'
import QueryPolicyAmendRetention from './QueryPolicyAmendRetention'
import QueryPolicyInstalments from './QueryPolicyInstalments'
export default {
  data() {
    return {
      headers: 0,
      polTabs: 0,
      hideSlider: undefined,
      showTab: true
    }
  },
  props: {
    functionId: String
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    commonDispatch() {
      return this.$store.state.commons.dispatch
    }
  },
  methods: {
    async doInit() {
      this.polTabs = 0
      this.$refs.policysummary.doInit()
      if (this.polMaster.totNoInstal > 1) {
        this.$refs.policyInstal.doInit()
      }
      this.setCommonDispatch()
      // this.$refs.policyAmend.doInit()
    },
    setCommonDispatch() {
      if (this.commonDispatch.key === 'ReviewClaim' || this.commonDispatch.key === 'QueryClaim') {
        this.showTab = false
      } else {
        this.showTab = true
      }
    },
    tabClass(index) {
      if (this.headers === index) {
        return 'tabCard tabActive'
      } else {
        return 'tabCard'
      }
    },
    doTab(index) {
      this.polTabs = index
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    QueryPolicySummary,
    QueryPolicyAmendRetention,
    QueryPolicyInstalments
  }
}
</script>

<style lang="scss">
@import '../../../../../assets/scss/underwriting.scss';
</style>
